import { render, staticRenderFns } from "./CategoriasContas.vue?vue&type=template&id=1734181a&"
import script from "./CategoriasContas.vue?vue&type=script&lang=js&"
export * from "./CategoriasContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports